import { render, staticRenderFns } from "./LessonEdit.vue?vue&type=template&id=5ef746e8&"
import script from "./LessonEdit.vue?vue&type=script&lang=ts&"
export * from "./LessonEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LessonEdit.vue"
export default component.exports